import getLocalizedValue from './getLocalizedValue'

export default getLocalizedValue
